import React, {Component} from 'react';
import DefaultCommissionRender from './components/DefaultCommissionRender';
import {get} from '../../../api';
import BootStrapPagedTable from '../../cmp/BootStrapPagedTable';
import RenderCommission from '../../cmp/RenderCommission';
import {connect, Provider} from 'react-redux';
import store from '../../../redux/store';
import {IntlProvider} from 'react-intl';
import {createRoot} from 'react-dom/client';
import {flushSync} from 'react-dom';

function ComponentHtml(Component){
    const div = document.createElement('div');
    const root = createRoot(div);
    flushSync(() => {
        root.render(Component);
    });
    return div.innerHTML;
}
class ProgramDetailsCommissions extends Component {

    state = {
        data: [],
        loading: false
    }


    componentDidMount() {
        this.loadSiteOffers().then(() => {
            this.loadHTMLPage();
        });
    }

    loadSiteOffers = () => {
        this.setState({loading: true});
        return get('/site_offers').then((data) => {
            this.setState({data, loading: false});
        }).catch((e) => {
            this.setState({loading: false});
        });
    }

    loadHTMLPage = () => {
        const {locale} = this.props;
        let l = locale && locale.startsWith("zh") ? locale.split("_").join("-") : locale;
        fetch(this.props.program_commissions_page).then((data) => data.text())
            .then((data) => {
                let html = data;
                 html = data.replace("{commission_value}", ComponentHtml(
                    <Provider store={store}>
                    <IntlProvider locale={l} messages={this.props.messages}>
                        <DefaultCommissionRender/>
                    </IntlProvider>
                </Provider>
                ))
                html = html.replace("{special_offers}", ComponentHtml(<Provider store={store}>
                    <IntlProvider locale={l} messages={this.props.messages}>
                        <RenderSpecialOffers data={this.state.data}/>
                    </IntlProvider>
                </Provider>))
                this.setState({html})
            })
    }


    render() {
        // return <HTMLComponent html={this.state.html}/>
        return (
            <div dangerouslySetInnerHTML={{__html:this.state.html}}/>
        );
    }
}

function RenderSpecialOffers({data}) {
    if (data.length === 0) {
        return <p>No special offers are running at the moment</p>;
    }
    return <RenderSpecialOffersList data={data}/>;


}

const columns = [
    {
        title: 'Product',
        dataIndex: 'offer_data',
        render: (offer_data) => {
            const {product, variation} = JSON.parse(offer_data);
            if (product && product.id)
                return (<div>
                    <span>{(product.name || '').replace(/(<([^>]+)>)/gi, "")}</span>
                    {
                        variation ?
                            <small className={'text-muted ml-2'}>{variation.name}</small>
                            : null
                    }
                </div>);
            return <span>Any</span>;
        }
    },
    {
        title: 'Commission',
        dataIndex: 'commission_type',
        key: 'commission_type',
        sorter: (a, b) => Number(a.commission_value) - Number(b.commission_value),
        render: (commission, item) => <RenderCommission commission_value={item.commission_value}
                                                        commission_type={item.commission_type}/>
    }
];


const collection_columns = [
    {
        title: 'Collection',
        dataIndex: 'offer_data',
        render: (offer_data) => {
            const {id, title} = JSON.parse(offer_data);
            if (title) return <span>{title}</span>;
            return <span>Any</span>;
        }
    },
    {
        title: 'Commission',
        dataIndex: 'commission_type',
        key: 'commission_type',
        sorter: (a, b) => Number(a.commission_value) - Number(b.commission_value),
        render: (commission, item) => <RenderCommission commission_value={item.commission_value}
                                                        commission_type={item.commission_type}/>
    }
];

function RenderSpecialOffersList({data}) {
    const products = data.filter((item) => item.offer_type === 'product');
    const collections = data.filter((item) => item.offer_type === 'collection');
    return (<div>
        {
            products.length > 0 &&
            <BootStrapPagedTable dataSource={products} columns={columns} per_page={500}/>
        }
        {
            collections.length > 0 &&
            <BootStrapPagedTable dataSource={collections} columns={collection_columns} per_page={500}/>
        }
    </div>);
}


const mapStateToProps = (state, props) => {
    const {locale, messages, default_commission_type, default_commission_value, show_commission_on_landing} = state.settings;
    return {
        default_commission_value,
        default_commission_type,
        show_commission_on_landing,
        locale, messages,
        program_commissions_page: state.settings.program_commissions_page || '/program_commissions.html'
    };
};


export default connect(mapStateToProps)(ProgramDetailsCommissions);
